// extracted by mini-css-extract-plugin
module.exports = {"checkoutFooter":"az_vl","footerBox":"az_wl","copyright":"az_xl","digicert":"az_yl"};